import request from '@/utils/requests.js'

// DICOM API Services
export const dicomService = {
 
  // Orthanc Sync - Lista de estudos DICOM do Orthanc
  async getOrthancStudies(params = {}) {
    return request({
      url: '/orthanc-sync/orthanc-studies',
      method: 'get',
      params
    })
  },

  // Obter link do visualizador para um study_uid específico
  async getViewerLink(studyUid) {
    return request({
      url: `/orthanc-sync/viewer-links/${studyUid}`,
      method: 'get'
    })
  }  
}
